export const it = {
  maintenanceMode: {
    title: 'Torneremo presto!',
    description:
      'Il nostro sito è attualmente in manutenzione per migliorare la tua esperienza.\nGrazie per la tua pazienza, torneremo online a breve!',
  },
};
